module.exports = __webpack_public_path__ + "img/whitecross.66f2760a.svg";